import { ClientProviderEnum } from "../../../../constants";
import { ClientProviderUtils } from "../../../../utils/clientProviderUtils";
import { useKambiMenuItemsPC } from "./Kambi/useKambiMenuItemsPC";
import { useKambiNumberOfItemsPC } from "./Kambi/useKambiNumberOfItemsPC";
import { useSpectateMenuItemsPC } from "./Spectate/useSpectateMenuItemsPC";
import { useSpectateNumberOfItemsPC } from "./Spectate/useSpectateNumberOfItemsPC";

export const usePCCategories = trackingInfo => {
  const clientProvider = ClientProviderUtils.getClientProvider();
  const useNumberOfItems =
    clientProvider === ClientProviderEnum.Kambi
      ? useKambiNumberOfItemsPC
      : useSpectateNumberOfItemsPC;

  useNumberOfItems();

  const useMenuItems =
    clientProvider === ClientProviderEnum.Kambi
      ? useKambiMenuItemsPC
      : useSpectateMenuItemsPC;

  const menuItems = useMenuItems(trackingInfo);

  return menuItems;
};
